(function ()
{
    "use strict";
    window.skyward = window.skyward || {};
    skyward.browseSeekInfo = {};

    /** @typedef {Object} SeekInfo - The current and nearby seek IDs for a browse.
     * @property {number?} seekId
     * @property {number?} prevSeekId
     * @property {number?} nextSeekId
     */

    /**
     * Get the persisted seek info for a browse
     *
     * @param {(string | Object)} browse - The string name or browse object to get seek info for
     * @return {SeekInfo?} The seek info from browsePrefernces
     */
    skyward.browseSeekInfo.get = function (browse)
    {
        var prefData = skyward.browsePreferences.getPreferences(browse);
        return getSeekInfoFromObject(prefData);
    };

    /**
     * Persist the seek info for a browse, if any.  Then return the browse's current seek info.  This is meant to be used internally by browse.js.
     *
     * @param {(string | Object)} browse - The string name or browse object the seek info is associated with
     * @param {Object} data - An object containing seek info to return or persist
     * @return {SeekInfo?} The seek info either that was passed in, or that has been persisted for the browse
     */
    skyward.browseSeekInfo.setAndGet = function (browse, data)
    {
        var seekInfo = getSeekInfoFromObject(data);

        if (!shouldSeekInfoBeTracked(browse))
        {
            return seekInfo;
        }
        // no seek info was passed in, get seek info from preferences
        if (!seekInfo)
        {
            return skyward.browseSeekInfo.get(browse);
        }
        if (isNaN(parseInt(seekInfo.seekId, 10)))
        {
            skyward.browseSeekInfo.clear(browse);
            return undefined;
        }
        skyward.browsePreferences.setPreferences(browse, seekInfo);
        return seekInfo;
    };

    /**
     * Remove the seek info for a browse.
     * @param {(string | Object)} browse - The string name or browse object to remove seek info for
     */
    skyward.browseSeekInfo.clear = function (browse)
    {
        if (!shouldSeekInfoBeTracked(browse))
        {
            return;
        }
        skyward.browsePreferences.setPreferences(browse,
        {
            seekId: null,
            prevSeekId: null,
            nextSeekId: null
        });
    };

    /**
    * Persist the selected row primary keys for the passed in browse
    *
    * @param {Object} browse - The browse object to save seek info for
    * @param {SeekInfo?} seekInfo - Optional seek info to save
    * @return {SeekInfo?} The seek info that was saved in browsePrefernces
    */
    skyward.browseSeekInfo.save = function (browse, seekInfo)
    {
        if (!shouldSeekInfoBeTracked(browse))
        {
            return undefined;
        }

        if (seekInfo !== undefined)
        {
            return skyward.browseSeekInfo.setAndGet(browse, seekInfo);
        }

        var data =
        {
            seekId: typeof browse.primaryKeys[browse.currentRow] === "number" ? browse.primaryKeys[browse.currentRow] : undefined,
            prevSeekId: typeof browse.primaryKeys[browse.currentRow - 1] === "number" ? browse.primaryKeys[browse.currentRow - 1] : undefined,
            nextSeekId: typeof browse.primaryKeys[browse.currentRow + 1] === "number" ? browse.primaryKeys[browse.currentRow + 1] : undefined
        };

        return skyward.browseSeekInfo.setAndGet(browse, data);
    };

    /**
     * Return the seek info of an object.  
     * If seekId is not specified, the default seek info will be returned.
     *
     * @param {Object} sourceObject - An object that may contain seek info
     * @return {SeekInfo|undefined} An object that contains the seek info properties from the sourceObject
     */
    function getSeekInfoFromObject(sourceObject)
    {
        if (!sourceObject || sourceObject.seekId === null || sourceObject.seekId === undefined)
        {
            return undefined;
        }
        var responseObject =
        {
            seekId: sourceObject.seekId,
            prevSeekId: sourceObject.prevSeekId,
            nextSeekId: sourceObject.nextSeekId
        };
        return responseObject;
    }

    /**
     * Return whether or not seek info should be tracked for the provided browse
     * If seekId is not specified, the default seek info will be returned.
     *
     * @param {(string | Object)} browseParam - The string name or browse object to check
     * @return {boolean} True when the browse should track seek info
     */
    function shouldSeekInfoBeTracked(browseParam)
    {
        var browse;
        if (typeof browseParam === "string")
        {
            browse = skyward.browse.browseList[browseParam];
        }
        else
        {
            browse = browseParam;
        }

        // TODO: PR 4471842 should make it so browse.isInDetailsPanel is more reliable, so checking browse.id.indexOf("detailsPanel_") should no longer be necessary.
        if ($.isEmptyObject(browse) || !browse.trackSeekInfo || browse.isInDetailsPanel || browse.id.indexOf("detailsPanel_") === 0)
        {
            return false;
        }

        // -1 is used as a fallback for on-the-fly browses in DefaultBrowseScriptRenderer
        if (browse.browseId === -1)
        {
            return false;
        }

        return true;
    }
})();
